/**
 * Alinha à direita do botão o painel aberto do `OverlayPanel` (o Prime o alinha à esquerda do alvo e
 * o painel de 271px passava da borda do modal), sem sair da janela.
 */
export function alinharPainelAoBotao(
  painel: HTMLElement | null | undefined,
  botao: HTMLElement | null | undefined,
): void {
  if (!painel || !botao) return;

  const margem = 8;
  const alvo = botao.getBoundingClientRect();
  const direita = alvo.right + window.scrollX;
  const esquerda = Math.max(margem, direita - painel.offsetWidth);

  painel.style.left = `${esquerda}px`;
}
